<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Container Expenses</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" small text to="/freight/expenses">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row class="subtitle-2 text--primary">
          <v-col cols="12" xs="12" md="6">
            <span style="color: red"> Container No: {{ dataItem.Name }}</span
            ><br />
            <span style="color: red"> Total Lines: {{ dataItem.Lines }}</span
            ><br />
            <span>
              Cost / Line:
              {{
                dataItem.LineCost && dataItem.LineCost.toLocaleString()
              }}</span
            ><br />
            <span>Date Received: {{ dataItem.DocDate }}</span>
          </v-col>

          <v-col cols="12" xs="12" md="6">
            <v-btn
              @click.native="expenseDialog = true"
              color="accent"
              text
              class="float-right"
              ><v-icon left>mdi-plus</v-icon>Add Expense</v-btn
            >
          </v-col>
        </v-row>

        <!-- manifest list -->
        <v-row>
          <v-col cols="12">
            <!-- start of table -->
            <v-data-table
              :headers="headers"
              :items="expenses"
              :search="search"
              :mobile-breakpoint="0"
            >
              <!-- action template -->
              <template v-slot:item.Amount="{ item }">
                {{ item.Amount.toLocaleString() }}
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>

          <snackbar ref="snackbar"></snackbar>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="expenseDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="accent" dense>
          <v-toolbar-title>
            <v-btn icon dark @click.native="expenseDialog = false">
              <v-icon dark>mdi-keyboard-backspace</v-icon>
            </v-btn>
            Expenses Dialog
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="expenseDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container class="docForm">
            <v-row justify="center" class="mt-5 subtitle-2 text--primary">
              <v-col cols="10">
                <v-row class="mb-2">
                  <v-col cols="12" xs="12" md="4">
                    <span style="color: red">
                      Container No: {{ dataItem.Name }}</span
                    ><br />
                    <span>Date Received: {{ dataItem.DocDate }}</span>
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <span style="color: red">
                      Total Lines: {{ dataItem.Lines }}</span
                    >
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <span>
                      Cost / Line:
                      {{
                        dataItem.LineCost && dataItem.LineCost.toLocaleString()
                      }}</span
                    >
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row class="mt-2">
                  <!-- editor -->
                  <editor
                    :docCreate="docCreate"
                    :initial="dataItem"
                    :categories="categories"
                    @data="save"
                  ></editor>
                  <!-- end -->
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "./editor.vue";
export default {
  components: {
    Editor,
  },
  computed: {
    ...mapGetters(["user"]),
  },
  data: () => ({
    dataItem: {},
    expenseDialog: false,
    loader: false,
    activeItem: {},
    Description: null,
    search: null,
    invoiceDialog: false,
    categories: [],
    manifestData: [],
    expenses: [],
    docCreate: true,
    headers: [
      { text: "Category", value: "vpm1.Name" },
      { text: "Amount", value: "Amount" },
      { text: "Account", value: "account.Name" },
      { text: "Description", value: "Description" },
      { text: "Date", value: "DocDate" },
    ],
  }),
  watch: {
    "$route.params.id": {
      handler: "getById",
      immediate: true,
    },
  },
  methods: {
    getById(val) {
      const self = this;
      this.$store
        .dispatch("get", `/stores/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.dataItem = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });

      // fetch manifest
      this.$store
        .dispatch("get", `/manifest/invoiced/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.manifestData = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });

      // expenses
      this.$store
        .dispatch("get", `/container/expenses/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.expenses = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    save(data) {
      const url = "/expense";
      const self = this;
      data.container_id = this.dataItem.id;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            location.reload();
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    getCategories() {
      const self = this;
      this.$store
        .dispatch("get", `/expense-categories`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.categories = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getExpenses() {
      const container_id = this.dataItem.id;
      this.$store
        .dispatch("get", `/container/expenses/${container_id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.expenses = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getCategories();
    this.getExpenses();
  },
};
</script>